import React, { FC } from 'react'
import FeaturedPost from './featuredPost'
import MainFeaturedPost from './mainFeaturedPosts'
import { useStaticQuery, graphql } from 'gatsby'

interface dataQuery {
  featuredMarkdownRemark: {
    edges: [
      {
        node: {
          id: string
          excerpt: string
          slug: string
          frontmatter: {
            date: Date
            description: string
            title: string
            image: {
              childImageSharp: {
                fluid: {
                  srcWebp: string
                }
              }
            }
            imageText: string
          }
        }
      }
    ]
  }
}

const Header: FC = () => {
  const featuredPosts: dataQuery = useStaticQuery(graphql`
    query {
      featuredMarkdownRemark: allMdx(
        sort: { order: DESC, fields: [frontmatter___date] }
        filter: { frontmatter: { featuredpost: { eq: true } } }
        limit: 3
      ) {
        edges {
          node {
            id
            excerpt(pruneLength: 250)
            slug
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              description
              title
              image: mainImage {
                childImageSharp {
                  fluid(quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp_tracedSVG
                  }
                }
              }
              imageText
            }
          }
        }
      }
    }
  `)

  const mainFeaturedPost = featuredPosts.featuredMarkdownRemark.edges[0].node

  return (
    <>
      <MainFeaturedPost
        excerpt={mainFeaturedPost.excerpt}
        post={{
          slug: mainFeaturedPost.slug,
          title: mainFeaturedPost.frontmatter.title,
          image:
            mainFeaturedPost.frontmatter.image.childImageSharp.fluid.srcWebp,
          imageText: mainFeaturedPost.frontmatter.imageText,
        }}
      />
      {featuredPosts.featuredMarkdownRemark.edges.slice(1).map(post => (
        <FeaturedPost
          key={post.node.id}
          post={{
            ...post.node.frontmatter,
            slug: post.node.slug,
            image: post.node.frontmatter.image?.childImageSharp.fluid.srcWebp,
            imageTitle: post.node.frontmatter.imageText,
          }}
          excerpt={post.node.excerpt}
        />
      ))}
    </>
  )
}

export default Header
